<template>
  <v-data-table
    :items="data"
    :headers="headers"
    :loading="loading"
    :server-items-length="paginator.total"
    :footer-props="footerProps"
    :hide-default-footer="hideDefaultFooter"
    class="elevation-1"
  >
    <template v-slot:item.options="{ item }">
      <v-btn
        text
        @click="$emit('rowClicked', item)"
      >
        <v-icon>mdi-eye</v-icon>
      </v-btn>
    </template>
  </v-data-table>
</template>

<script>
import ListMixin from '@/mixins/list-mixin.vue'

export default {
  name: 'ProjectListPage',
  components: { },
  mixins: [ListMixin],
  props: {
    headers: {
      type: Array,
      required: true,
    },
    paginator: {
      type: Object,
      required: true,
    },
    data: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      default: true,
    },
    hideDefaultFooter: {
      type: Boolean,
      default: true,
    },
    options: {
      type: Object,
      default: () => ({}),
    },
  },
}
</script>
